import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AppHome.css";
import '../Admin/Admin.css';
import Header from "../Home/Header";

export default function NewMemberHome() {
  const navigate = useNavigate();

         useEffect(() => {
                const role = sessionStorage.getItem("userRole");
                if (!role) navigate("/");
              }, [navigate]);

  return (
    <div className="dashboard">

          <Header />

      <div className="welcome-container">
        <h1 className="welcome-title">PAYMENT & EXPENSE MANAGEMENT</h1>


        <div className="button-container">
          <button className="big-btn" onClick={() => navigate("/payment-management")}>
            📝 Payments
          </button>

          <button className="big-btn blue" onClick={() => navigate("/expenditure-management")}>
            📝 Expenses
          </button>

           <button className="big-btn blue" onClick={() => navigate("/nml")}>
                      📝 Monthly Revenue Report
                    </button>

                    <button className="big-btn blue" onClick={() => navigate("/nmlnet")}>
                                          📝 Net Income
                                        </button>




        </div>
      </div>
    </div>
  );
}
